import { Component, Input } from '@angular/core';
import { ControlService } from '../library/control.service';
import { PlayerService } from '../library/player.service';
import { DeviceSettingsService } from '../library/device-settings.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { CallStoreService } from '../library/call-store/call-store.service';
@Component({
  selector: 'app-call-pause',
  templateUrl: './call-pause.component.html',
  styleUrls: ['./call-pause.component.scss'],
  standalone: false
})
export class CallPauseComponent {
  @Input() control: ControlService | undefined;
  @Input() player: PlayerService | undefined;
  @Input() deviceSettings: DeviceSettingsService | undefined;

  constructor(
    private amplitudeService: AmplitudeService,
    private controlService: ControlService,
    private logger: LoggerService,
    private callStore: CallStoreService
  ) {}

  protected get isRestoring() {
    return this.control?.isResumeInProgress;
  }

  ngAfterViewInit(): void {
    this.player?.loadVideoCurrentTime('video-paused-simulation');
  }

  public sendAmplitudeClickPauseEvent(): void {
    // Sending the Event of Clicking on Pause From Pause Modal to Amplitude
    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.PAUSE_MODAL_CLICK_DEVICE_SETTINGS,
      {
        call_type: this.controlService?.callType,
      }
    );
  }

  public handleViewSettingsClick(): void {
    this.sendAmplitudeClickPauseEvent();
    this.deviceSettings?.displayDeviceSettingsModal(true);
  }

  public handleResumeClick(): void {
    this.logger.log('[CALL] pause screen - resume click');

    this.sendAmplitudeClickPauseEvent();
    this.control?.togglePause();
  }
}
